import { cn } from '@/lib/utils'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  }

  return (
    <div className={cn('flex justify-center items-center py-8', className)}>
      <div 
        className={cn(
          'animate-spin rounded-full border-2 border-border border-t-primary',
          sizeClasses[size]
        )}
      />
    </div>
  )
}